import { useState } from 'react';

const FAQS = [
  {
    q: 'What are the best cabins in Highlands, NC?',
    a: 'Highlands offers a wide range of cabins from luxury rentals to cozy mountain retreats. Highly rated options like Glen Falls Luxury Cabin stand out for their location, amenities, and guest experience.',
  },
  {
    q: 'Are there pet friendly cabins in Highlands, NC?',
    a: 'Yes, many cabins in Highlands, NC are pet friendly and allow guests to bring dogs. It\'s important to check each property\'s specific pet policy before booking.',
  },
  {
    q: 'Are there cabins near downtown Highlands?',
    a: 'Yes, there are cabins located just minutes from downtown Highlands, offering easy access to restaurants, shops, and local attractions while still providing privacy.',
  },
  {
    q: 'What amenities do cabins in Highlands, NC typically offer?',
    a: 'Many cabins include features like fireplaces, outdoor decks, mountain views, full kitchens, and access to nearby hiking trails and waterfalls.',
  },
  {
    q: 'When is the best time to visit Highlands, NC?',
    a: 'Highlands is a year round destination, with cool summers, beautiful fall foliage, and peaceful winter getaways.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="bg-[#F5F1EB] py-24 px-6 lg:px-14">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-[#C9A96E] text-xs tracking-[0.3em] uppercase font-jost mb-4">/ Common Questions</p>
          <h2 className="font-cormorant text-5xl text-[#1A1A18] font-light">
            FAQs About Cabins<br /><em className="italic">in Highlands, NC</em>
          </h2>
        </div>

        <div className="space-y-3">
          {FAQS.map((faq, i) => (
            <div key={i} className="bg-white rounded-2xl overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between gap-4 px-8 py-6 text-left cursor-pointer"
              >
                <h4 className="font-cormorant text-xl text-[#1A1A18] font-medium leading-snug">
                  <a id={`faq-${i}`}>{faq.q}</a>
                </h4>
                <div className="w-6 h-6 flex items-center justify-center shrink-0">
                  <i className={`${openIndex === i ? 'ri-subtract-line' : 'ri-add-line'} text-[#2D4A3E] text-lg`} />
                </div>
              </button>
              {openIndex === i && (
                <div className="px-8 pb-7">
                  <p className="text-[#5C5850] font-jost text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
